import BotaoTabela from "../../../Componentes/BotaoTabela";

export default function BlackListRegistro({
    dados,
    dadosUsuario,
    permissao,
    clicouExcluir,
    clicouEditar
}) {

    return (
        <tr onClick={clicouEditar} className={`clicavel`}>
            <td className="estreito text-center font-weight-bold">{dados.id}</td>
            <td>{dados.nome}</td>
            <td>{dados.email}</td>
            <td>{dadosUsuario.nome}</td>
            <td className="text-nowrap estreito">
                {(parseInt(permissao.clientes) > 1) &&
                    <BotaoTabela
                        onClick={clicouEditar}
                        icone={["fas", "pencil-alt"]}
                        className='mr-2'
                    >
                        Editar
                    </BotaoTabela>
                }
                {(parseInt(permissao.clientes) > 1) && <BotaoTabela 
                    onClick={clicouExcluir}
                    icone={["fas", "trash"]}
                >
                    Excluir
                </BotaoTabela>}
            </td>
        </tr>
    )
}